import React, { Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import ROUTES_ENUMS from 'routes/url.enum';
import {
  AboutUs,
  Categories,
  Checkout,
  ContactUs,
  EventDetails,
  Faq,
  Home,
  MyBookings,
  MyProfile,
  MyWishlist,
  PageNotFound,
  TermsConditon,
  TopPackages,
  TourDetails,
} from 'routes/routes';
import Register from 'components/authentication/register';
import RouteContentLoader from '../route-loader/RouteContentLoader';

const pageTransition = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
  transition: { duration: 0.22, ease: [0.25, 0.1, 0.25, 1] },
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <Suspense fallback={<RouteContentLoader />}>
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={location.pathname}
          initial={pageTransition.initial}
          animate={pageTransition.animate}
          exit={pageTransition.exit}
          transition={pageTransition.transition}
          className="w-full"
        >
          <Routes location={location}>
            <Route path={ROUTES_ENUMS.HOME} element={<Home />} />
            <Route path={ROUTES_ENUMS.TOUR_DETAILS} element={<TourDetails />} />
            <Route path={ROUTES_ENUMS.EVENT_DETAILS} element={<EventDetails />} />
            <Route path={ROUTES_ENUMS.CHECKOUT} element={<Checkout />} />
            <Route path={ROUTES_ENUMS.MY_BOOKINGS} element={<MyBookings />} />
            <Route path={ROUTES_ENUMS.MY_PROFILE} element={<MyProfile />} />
            <Route path={ROUTES_ENUMS.MY_WISHLIST} element={<MyWishlist />} />
            <Route path={ROUTES_ENUMS.CATEGORIES} element={<Categories />} />
            <Route path={ROUTES_ENUMS.TOP_PACKAGES} element={<TopPackages />} />
            <Route path={ROUTES_ENUMS.FAQ} element={<Faq />} />
            <Route path={ROUTES_ENUMS.ABOUT_US} element={<AboutUs />} />
            <Route path={ROUTES_ENUMS.TERMS_CONDITION} element={<TermsConditon />} />
            <Route path={ROUTES_ENUMS.CONTACT_US} element={<ContactUs />} />
            <Route path={ROUTES_ENUMS.REGISTER} element={<Register />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </Suspense>
  );
};

export default AnimatedRoutes;
